import styled from '@emotion/styled'
import React, { useRef, useState } from 'react'
import useOnClickOutside from '../../hooks/useOnClickOutside'
import { Box } from '../Box/Box'
import { SecondaryButton } from '../Button/Button'
import { Icon } from '../Icon/Icon'
import { Inline } from '../Inline/Inline'

export type Option = {
  text: string
  onClick: () => any
}

export interface DropdownButtonProps {
  label: string
  options: Option[]
  // optionsExpand?: 'right' | 'left' // TODO - future feature
}

export const DropdownButton: React.FC<DropdownButtonProps> = ({
  label = 'Label',
  options = []
  // optionsExpand = 'left'
}) => {
  const [showOptions, setShowOptions] = useState(false)
  const toggleShowOptions = () => setShowOptions(!showOptions)
  const optionsRef = useRef(null)
  useOnClickOutside(optionsRef, () => setShowOptions(false))

  return (
    <Box position="relative" ref={optionsRef} display="inline-block">
      <SecondaryButton onClick={toggleShowOptions}>
        <Inline space="xs" alignY="center">
          {label}
          <Icon name="arrow" tone="action" size="s" rotate={showOptions ? 180 : 0} />
        </Inline>
      </SecondaryButton>
      <StyledDropdown radius="s" hidden={!showOptions}>
        {options.map((option) => (
          <StyledDropdownItem
            radius="s"
            onClick={() => {
              setShowOptions(false)
              option.onClick()
            }}
            key={option.text}
          >
            {option.text}
          </StyledDropdownItem>
        ))}
      </StyledDropdown>
    </Box>
  )
}

const StyledDropdown = styled(Box)`
  position: absolute;
  // TODO - future feature - set left: 0 when optionsExpand is 'right' and right: 0 when optionsExpand is 'left'
  right: 0;
  min-width: 170px;
  background: var(--colors-foreground);
  z-index: 2;
  padding: 0;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
`

const StyledDropdownItem = styled(Box)`
  cursor: pointer;
  padding: var(--space-inset-squish--m);
  border-radius: 0;

  &:not(:last-of-type) {
    border-bottom: 1px solid var(--colors-hairline);
  }

  &:first-of-type {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &:last-of-type {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  }

  &:hover {
    background: var(--card--background);
  }
`
